import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-300/60 bg-gradient-to-b from-background-100 to-background-200">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">51cg5</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              51cg5 汇总热门话题榜与实时热度追踪，帮助你快速掌握话题排行、热议焦点，随时跟进当前最受关注的事件动态。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold text-foreground-950">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 51cg5 · 热门榜与实时热度追踪。页面内容为演示展示，不代表真实事件。</span>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#top" className="cursor-pointer hover:text-primary-600">
              回到顶部
            </a>
            <a href="#ranking" className="cursor-pointer hover:text-primary-600">
              热门榜
            </a>
            <a href="#trend" className="cursor-pointer hover:text-primary-600">
              实时热度
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}